import * as yup from "yup";

export const createCustomerSchema = (v, t, isEditMode) => {
  return yup.object().shape({
    fullName: v.string().required(),
    phoneNumberCode: v.string().required(),
    phoneNumber: yup.string().required(t("thisFieldIsRequired")).matches(/^5\d{8}$/, t("invalidPhoneNumber")),
    cityId: v.string().required(),
    age: v.number({ min: 1, max: 120 }).required(),
    gender: v.string().required(),
  });
};
